<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      VisorCUE - {{ user?.entidad?.name || 'Admin' }}
    </a>
  </div>
</div>

<div class="header-container">
  <div class="row" *ngIf="this.askRolService.esSuperAdminEntidad || this.askRolService.esAdminEntidad">
    <div>
      <button nbButton shape="round" size="small" status="basic" (click)="newTask()">Nueva Tarea</button>
    </div>
    <div class="col-sm-2">
      <button nbButton shape="round" size="small" status="basic" (click)="newRecord()">Nuevo Registro</button>
    </div>
  </div>
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name">
      </nb-user>
      <button nbButton *ngIf="!user?.name" (click)="gotoLogin()"><nb-icon icon="person-outline" ></nb-icon>Iniciar Sesión</button>
    </nb-action>
  </nb-actions>
</div>
